<template>
  <div class="spray">
    <Page :search-bar="searchBar" :table="table" :pagination="pagination" :hiddenOperate="true"></Page>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
import { getEquipmentList } from '@/api/dataDictionary'

export default {
  components: {
    Page
  },
  data () {
    return {
      searchBar: {
        list: [{
          type: 'input',
          prop: 'equipmentName',
          label: '设施名称',
          placeholder: '请输入'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: this.searchBarform
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      params: {
        equipmentName: ''
      },
      table: {
        selection: false, // 是否开启选择框
        tableInfo: [{
          key: 'num',
          name: '序号',
          minWidth: 30
        }, {
          key: 'equipmentTypeName',
          name: '设施类型',
          minWidth: 80
        }, {
          key: 'equipmentName',
          name: '设施名称',
          minWidth: 60
        }],
        tableData: []
      },
      pagination: {
        total: 0,
        currentPage: 1,
        size: 10,
        currentChange: (page) => {
          this.handleCurrentChange(page)
        },
        sizeChange: (size) => {
          this.handleSizeChange(size)
        }
      }
    }
  },
  mounted () {
    this.getEquipmentList()
  },
  methods: {
    async getEquipmentList () {
      const {data} = await getEquipmentList({
        equipmentName: this.params.equipmentName,
        size: this.pagination.size,
        current: this.pagination.currentPage
      })
      this.pagination.total = data.total
      this.table.tableData = data.records
      this.table.tableData.forEach((item, idx) => {
        // item.num = idx + 1
        item.num = (this.pagination.currentPage - 1) * this.pagination.size + idx + 1
        item.equipmentTypeName = item.equipmentType === 1 ? '加热设备' : '接线箱'
      })
    },
    searchBarform (params) {
      this.params = {...this.params, ...params}
      const {equipmentName} = this.params
      if (equipmentName && equipmentName.length > 20) {
        this.$message({
          type: 'warning',
          message: '搜索的长度不能超过20字'
        })
        return
      }
      this.pagination.currentPage = 1
      this.getEquipmentList()
    },
    resetList () {
      this.pagination.currentPage = 1
      this.params = {
        equipmentType: ''
      }
      this.getEquipmentList()
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.$nextTick(() => {
        this.getEquipmentList()
      })
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.$nextTick(() => {
        this.getEquipmentList()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__body-wrapper {
  height: calc(100% - 32px);
  overflow-y: auto;
}
.spray {
  width: 100%;
  height: 100%;
}
</style>